import { render } from "./ITConsultancy.vue?vue&type=template&id=91c052c8"
import script from "./ITConsultancy.vue?vue&type=script&lang=js"
export * from "./ITConsultancy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__